import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import ScrollableWrapper from "../../../../common/ScrollableWrapper";
import { todayISO } from "../../helpers/planDates";
import { useNutritionPlan } from "../../store/useNutritionPlan";
import WeekDayRow from "./WeekDayRow";

/**
 * Week view: one `WeekDayRow` per day, Monday first (mobile parity). When the
 * week holds today, that row starts expanded and the list scrolls to it.
 */
const WeekPlanView = () => {
  const { activeWeek } = useNutritionPlan();
  const todayRef = useRef<HTMLDivElement>(null);
  const weekId = activeWeek?.id;

  // After the week renders, bring today's row to the top of the list. Keyed
  // on the week so stepping back to this week scrolls again.
  useEffect(() => {
    todayRef.current?.scrollIntoView({ block: "start" });
  }, [weekId]);

  if (!activeWeek) return null;

  const today = todayISO();
  const days = [...(activeWeek.daily ?? [])].sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  return (
    <ScrollableWrapper customPadding="8px">
      <Box sx={styles.list}>
        {days.map((day) => {
          const isToday = day.date === today;
          return (
            <WeekDayRow
              key={day.date}
              ref={isToday ? todayRef : undefined}
              day={day}
              isToday={isToday}
            />
          );
        })}
        <Box sx={{ height: "60px" }} />
      </Box>
    </ScrollableWrapper>
  );
};

export default WeekPlanView;

const styles = {
  list: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "16px",
  },
};
